import { render, staticRenderFns } from "./DatasetSummary.vue?vue&type=template&id=531728dc&scoped=true"
import script from "./DatasetSummary.vue?vue&type=script&lang=js"
export * from "./DatasetSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531728dc",
  null
  
)

export default component.exports